import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login, checking } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (checking) return <div className="min-h-screen grid place-items-center text-charcoal-soft">Loading...</div>;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, pwd);
      nav("/admin");
    } catch (er) {
      setErr(er?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-bone-alt px-6 py-12">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-2xl border border-black/5 shadow-sm p-8 md:p-10" data-testid="admin-login-form">
        <div className="w-12 h-12 rounded-xl bg-forest text-bone grid place-items-center mb-6">
          <Lock className="w-5 h-5" />
        </div>
        <h1 className="text-3xl font-display font-bold text-forest mb-2">Admin sign in</h1>
        <p className="text-charcoal-soft mb-6 text-sm">Manage blog, city pages, leads, and more.</p>

        <label className="text-sm font-semibold text-charcoal mb-1.5 block">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-3 rounded-lg border border-black/10 mb-4 focus:border-forest focus:ring-2 focus:ring-forest/20 outline-none"
          required
          data-testid="login-email-input"
        />

        <label className="text-sm font-semibold text-charcoal mb-1.5 block">Password</label>
        <input
          type="password"
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          className="w-full p-3 rounded-lg border border-black/10 mb-5 focus:border-forest focus:ring-2 focus:ring-forest/20 outline-none"
          required
          data-testid="login-password-input"
        />

        {err && <p className="text-red-600 text-sm mb-4" data-testid="login-error">{String(err)}</p>}

        <button type="submit" disabled={busy} className="w-full btn-secondary py-3 disabled:opacity-50" data-testid="login-submit-button">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
        </button>
      </form>
    </div>
  );
}
